<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field
          id="prompt-name"
          v-model="node.name"
          label="Name"
          dense
          hide-details
        >
        </v-text-field>
      </v-col>
    </v-row>
    <!-- ====================== เลือก Gen AI รูปแบบต่างๆ ====================== -->
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-select
          v-model="property.gen_ai"
          :items="genAIList"
          item-text="name"
          item-value="name"
          label="Gen AI"
          hide-details
          clearable
          clear-icon="fa-times"
        >
        </v-select>
      </v-col>
    </v-row>
    <!-- ======================End เลือก Gen AI รูปแบบต่างๆ ====================== -->
    <!-- ======================Message ====================== -->
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <div class="m-b-5">Message</div>
        <v-textarea
          id="description"
          class="textarea-input"
          v-model="property.message"
          label=""
          rows="4"
          solo
          hide-details
        ></v-textarea>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.message"
          :drawFlowItems="drawFlowItems"
          :property="'message'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>
    <!-- ======================End Message ====================== -->
    <!-- ======================Remember last =เอากี่ข้อความสุดท้าย ====================== -->
    <div class="m-t-15">
      <v-row class="m-l-align">
        <v-col cols="12" sm="6" lg="6">
          <div>
            Remember last
          </div>
        </v-col>
        <v-col class="d-flex" cols="12" sm="5" lg="5">
          <div>
            <v-text-field
              v-model="property.remember_last"
              type="number"
              step="1"
              min="0"
              max="99"
              dense
              reverse
              hide-details
              class="margin0 padding0 width50px"
              @blur="setPropertyData('remember_last')"
            ></v-text-field>
          </div>
          <div class="ml-2">messages</div>
        </v-col>
      </v-row>
      <!-- ======================End Remember last =เอากี่ข้อความสุดท้าย ====================== -->
      <!-- ======================Request timeout ====================== -->
      <v-row class="m-l-align">
        <v-col class="p-b-0" cols="12" sm="6" lg="6">
          <span>Request timeout</span>
        </v-col>
        <v-col class="d-flex" cols="12" sm="5" lg="5">
          <div>
            <v-text-field
              class="margin0 padding0 width50px"
              v-model="property.setting.timeout"
              type="number"
              @blur="setPropertyData('timeout')"
              hide-details
              dense
              reverse
            ></v-text-field>
          </div>
          <div class="ml-2">seconds</div>
        </v-col>
      </v-row>
      <!-- ======================End Request timeout ====================== -->
    </div>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import _ from 'lodash'

import apiGenAI from '@/apis/gen_ai'
import NoteComponent from '../../../components/note'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    // start: Object,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  data() {
    return {
      property: {},
      genAIList: [],
      //=== use for Intellisense ===-->
      isOpenIntellisense: false,
      start: -1,
      isKeyTab: false,
      eventKey: '',
      //=== use for Intellisense ===-->
      lastValueRememberLast: 0, //ใช้เก็บ ค่าเดิมก่อนแก้ไข (last valid value)
      lastValueSettingTimeout: 0
    }
  },
  watch: {},
  async created() {
    this.property = this.node.property
    this.getListProsona()
    this.lastValueRememberLast = this.property.remember_last //ใช้เก็บ ค่าเดิมก่อนแก้ไข (last valid value)
    this.lastValueSettingTimeout = this.property.setting.timeout
  },
  methods: {
    setPropertyData(property) {
      const numberPattern = /^\d+$/
      //เช็คว่า user กรอกอะไรมา ถ้าเป็นค่าอื่นไม่ใช่เลข ตอนsave ได้ NaN
      //ถ้าได้ NaN ให้ set ค่าเป็นค่า last valid value
      let val = 10
      if (property == 'remember_last') {
        if (!numberPattern.test(this.property.remember_last)) {
          this.property.remember_last = this.lastValueRememberLast
        } else {
          val = this.property.remember_last

          if (val < 1) {
            val = 1
          }
          this.property.remember_last = parseInt(val)
          //ถ้ายังเป็นตัวเลข ให้เก็บค่าล่าสุดไว้
          this.lastValueRememberLast = this.property.remember_last
        }
      } else {
        if (!numberPattern.test(this.property.setting[property])) {
          // If input contains non-numeric characters, reset properties
          val = this.lastValueSettingTimeout
          this.property.setting[property] = parseFloat(val).toFixed(1)
        } else {
          val = this.property.setting[property]
          if (val < 0) {
            val = 0
          }
          this.property.setting[property] = parseFloat(val).toFixed(1)
          this.lastValueSettingTimeout = this.property.setting[property]
        }
      }
    },
    // ========== use for Gen ===========
    async getListProsona() {
      try {
        const getProsona = await apiGenAI.getListGenAI()
        const { data } = getProsona
        data.forEach(item => {
          //   console.log(item.name) // Output the 'name' property of each object
          this.genAIList.push(item.name)
        })
      } catch {}
    },
    //=== use for Intellisense ===-->
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter(e) {
      if (e.keyCode === 13 && this.start > -1) {
        this.eventKey = 'enter'
        this.start = -1
        e.preventDefault()
      }
      this.eventKey = 'enter'
      this.start = -1
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      if (property == 'message') {
        this.property.message = data
      }
    }
    //=== use for Intellisense ===-->
  }
}
</script>

<style lang="scss" scoped>
// ::v-deep .v-text-field__slot > input,
// ::v-deep .v-text-field__slot > .v-select__slot {
//   margin: 0px !important;
//   padding: 0px !important;
// }
.boost-scroll {
  // height: 0px;
  // margin-bottom: 10px;
  width: 150px;
  max-width: 150px;
}
.boost-text {
  text-align: left;
  width: 15px;
}
.font-size-body {
  width: 300px;
  display: flex;
  text-align: justify;
  text-justify: inter-word;
  padding-left: 4px;
  margin-left: 4px;
  padding-right: 4px;
  margin-right: 4px;
  margin-bottom: 0px;
}
.padding-tooltip {
  padding-left: 12px;
  padding-bottom: 0px;
  margin-right: 12px;
}
// .col {
//   flex-basis: auto;
//   display: block;
// }
</style>
